import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { filter, first, length, map } from "@pdfking/rfunc"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import { make_absolute_url } from "@pdfking/workflow/utils/urlutilities"
import selector from "../../dom/selector"
import { CloseMixin } from "../../mixins/Close"
import { FreezeMixin } from "../../mixins/Freeze"
import keyboard from "../../state/keyboard"
import cx from "../../utils/cx"
import navigate from "../navigate"
import { SLIDESHOW_VIEW } from "../urls"

export const Slideshow = CreateRenderFunction({
  computed: {
    ...proxy(keyboard(), {
      ARROW_DOWN: "down_pressed",
      ARROW_LEFT: "left_pressed",
      ARROW_RIGHT: "right_pressed",
      ARROW_UP: "up_pressed",
    } as const),
    current() {
      const target = make_absolute_url(this.selected)
      return (
        first(filter((e: any) => e.src == target, this.images)) ||
        first(this.images)
      )
    },
    current_index() {
      return (this.images as { src: string }[]).indexOf(this.current)
    },
    images() {
      return this.selector
        ? map(
            (e: HTMLImageElement) => ({
              description: e.alt,
              src: make_absolute_url(e.getAttribute("data-slide-src") || e.src),
              title: e.title,
            }),
            selector(this.selector)
          )
        : []
    },
    translations: () => make_translations(["actions"]),
  },
  data: {
    toggled_class: "modal-body",
  },
  methods: {
    goto(position: number) {
      let next = position

      if (next + 1 > length(this.images)) next = 0
      if (next < 0) next = length(this.images) - 1

      navigate(SLIDESHOW_VIEW, {
        selected: this.images[next].src,
        selector: this.selector,
      })
    },
    next() {
      this.goto(this.current_index + 1)
    },
    prev() {
      this.goto(this.current_index - 1)
    },
  },
  mixins: [CloseMixin, FreezeMixin],
  props: {
    selected: "",
    selector: "",
  },
  render() {
    return (
      <div
        class="modal fade show opacity-100 modal p-3 d-flex align-items-center justify-content-center"
        onClick={this.close}
      >
        <div
          class="modal-dialog modal-fullscreen bg-white rounded"
          onClick={(e: Event) => e.stopPropagation()}
          style="height: calc(100vh - 50px); width: calc(100vw - 50px)"
        >
          <div class="modal-content position-relative rounded">
            <div class="carousel carousel-dark slide h-100 rounded">
              <div class="carousel-inner w-100 h-100 rounded">
                <img
                  class="carousel-item active img-cover w-100 h-100 rounded"
                  src={this.current.src}
                  title={this.current.title}
                />
              </div>

              <div class="carousel-indicators">
                {this.images.map((image: any, index: number) => (
                  <button
                    class={cx({ active: image.src == this.current.src })}
                    data-bs-target
                    key={index}
                    onClick={() => this.goto(index)}
                    title={image.title}
                    type="button"
                  ></button>
                ))}
              </div>

              <button
                class="carousel-control-prev"
                onClick={(e: Event) => {
                  e.preventDefault()
                  this.prev()
                }}
                type="button"
              >
                <span class="carousel-control-prev-icon"></span>
              </button>
              <button
                class="carousel-control-next"
                onClick={(e: Event) => {
                  e.preventDefault()
                  this.next()
                }}
                type="button"
              >
                <span class="carousel-control-next-icon"></span>
              </button>
            </div>

            <button
              class="btn-close position-absolute top-0 end-0 mx-4 my-4 p-2 rounded-circle border bg-light z-3"
              onClick={this.close}
              title={this.translations.actions.CLOSE}
              type="button"
            />
          </div>
        </div>
      </div>
    )
  },

  watch: {
    down_pressed(v: boolean) {
      if (v) this.next()
    },
    left_pressed(v: boolean) {
      if (v) this.prev()
    },
    right_pressed(v: boolean) {
      if (v) this.next()
    },
    up_pressed(v: boolean) {
      if (v) this.prev()
    },
  },
})
